export enum BasaltSystemScope {
  DONATION_GUIDE = 1,
  ADMIN = 2,
  FUND_ADMIN = 3,
  RECIPIENT = 4,
}
